module.exports = __webpack_public_path__ + "img/user-icon.f1c50cf3.png";